import Axios from "axios";
import { BaseService } from "./BaseService";
import { Tarea, TareaPaginaFiltro, TareaPerfil } from "@/model/Tarea";

BaseService.loadAxios();

const RESOURCE_NAME = "/Tarea";

export class TareaService {
    public static async getTareasAsync() {
        return await Axios.get(RESOURCE_NAME);
    }

    public static async getTareasPerfil(id: string) {
        return await Axios.get(`${RESOURCE_NAME}/perfil/${id}`);
    }    

    public static async grabarTareaAsync(tarea: Tarea) {
        return await Axios.post(RESOURCE_NAME + '/add', tarea);
    }

    public static async actualizarTareaAsync(tarea: Tarea) {
        return await Axios.put(RESOURCE_NAME, tarea);
    }

    public static async quitarTarea(id: number) {
        return await Axios.delete(`${RESOURCE_NAME}/${id}`);
    }    

    public static async getTareasPerfilAsync(id_empresa?: string, id_tarea?: string, id_perfil?: string) {
        return await Axios.get(`${RESOURCE_NAME}/responsable?id_empresa=${id_empresa || ''}&id_tarea=${id_tarea || ''}&id_perfil=${id_perfil || ''}`);
    }
    
    public static async asignarPerfilesAsync(perfil: TareaPerfil){
        return await Axios.post(RESOURCE_NAME + "/asignar/perfiles", perfil);
    }
    
    public static async getTareasPaginaAsync(filtro: TareaPaginaFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/tareas/pagina`, filtro);        
    }
    
    public static async actualizarTareasPagina(filtro: TareaPaginaFiltro) {
        return await Axios.post(`${RESOURCE_NAME}/pagina/actualizar`, filtro);
    }
}